import React from "react";
import { connect } from "react-redux";

import "./campaignResult.css";
import campaignResultDefaultImg from '../../assets/images/campaignResult-default.png'
import DraftDetails from "./modal/DraftDetails";
import { cancelSubscription, compAccount } from "../../actions/index";

export class CampaignResult extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      DraftDetailsModal: false
    }
  }


  calculatePaymentMethod = (uData) => {

    if ((uData.AccountStatus === 'f' || uData.AccountStatus === 'a') || uData.WhoIsMyMaster) {
      return 'Not Applicable'
    } else {
      if (((uData.payPalInfo && uData.payPalInfo.Canceled) && !uData.StripeSubscriptionID) || (!uData.payPalInfo && !uData.StripeSubscriptionID)) {
        return "Plan Canceled"
      }
      if (uData.StripeSubscriptionID) {
        return 'Stripe'
      } else {

        return 'PayPal'
      }

    }

  }

  getImportantLink = (token, message, label) => {
    return (
      <a target='_blank' rel="noopener noreferrer" href={`https://www.gmass.co/gmass/showmessage?TokenID=${token}&messageid=${message}`}> {`${label}`}</a>
    )
  }

  toggleDraftDetails = () => {
    this.setState({ DraftDetailsModal: !this.state.DraftDetailsModal })
  }


  renderCampaignData = (cData, uData) => {
    return (
      <React.Fragment>
        <div className="CampaignResult-campaignInfo-data">
          <div className="data-field">
            <div className="data-parameter">Campaign ID</div>
            <div className="data-value tooltip">{cData.campaign.id}
              {/* <span class="tooltiptext">
            <b>CreatedAt: </b>{new Date(cData.campaign.InsertedOn).toGMTString()}<br />
            <b>LastSentAt: </b>{new Date(cData.campaign.LastSent).toGMTString()}
          </span>*/}


              {(cData.schedule.Parameters || cData.schedule.PValue) &&

                <span style={{ fontSize: '0.8em', color: 'red' }}>


                  {cData.schedule.Parameters && `${parseInt(JSON.parse(cData.schedule.Parameters).Recur) ? ' ( Recurring ) ' : ''}`}
                  {cData.schedule.PValue && `${parseInt(JSON.parse(cData.schedule.PValue).Recur) ? ' ( Recurring ) ' : ''}`}

                </span>
              }

            </div>
          </div>
          <div className="data-field">
            <div className="data-parameter">From EmailAddress</div>
            <div className="data-value"> {cData.campaign.FromAddress}
              <span style={{ fontSize: '0.8em', color: 'red' }}>{`${cData.campaign.FromAddress.includes(uData[0].EmailAddress) ? '' : ' ( Alias ) '}`}</span>
            </div>
          </div>
          <div className="data-field">
            <div className="data-parameter">CreatedAt</div>
            <div className="data-value">{new Date(cData.campaign.InsertedOn).toGMTString()}</div>
          </div>
          <div className="data-field">
            <div className="data-parameter">LastSentAt</div>
            <div className="data-value">{new Date(cData.campaign.LastSent).toGMTString() ? new Date(cData.campaign.LastSent).toGMTString() : 'NA'}</div>
          </div>
          <div className="data-field">
            <div className="data-parameter">Important Links</div>
            <div className="data-value">
              {cData.campaign.GmailMessageIdOfSent ? this.getImportantLink(cData.campaign.TokenID, cData.campaign.GmailMessageIdOfSent, 'Show Campaign') : 'NA'}{' '}|{' '}
              {cData.campaign.GmailMessageIdOfSent ? (<a href={`https://www.gmass.co/gmass/ShowDraft?tokenid=${cData.campaign.TokenID}&DraftID=${cData.schedule.Parameters ? JSON.parse(cData.schedule.Parameters).DraftId : JSON.parse(cData.schedule.PValue).DraftId}`}
                target='_blank' rel="noopener noreferrer" >
                Show Draft
              </a>) : 'NA'}{' '}|{' '}
              {cData.campaign.GmailMessageIdOfReport ? this.getImportantLink(cData.campaign.TokenID, cData.campaign.GmailMessageIdOfReport, 'Show Report') : 'NA'}{' '}|{' '}
              {cData.campaign.GmailMessageIdOfSent ? (<a href={`https://www.gmass.co/spamtest?campaignid=${cData.campaign.id}&emailaddress=${uData[0].EmailAddress}`} target='_blank' rel="noopener noreferrer" >
                Seed Test
              </a>) : 'NA'}{' '}|{' '}
              {cData.schedule.UniqueID ?
                (<a href={`https://www.gmass.co/gmass/ResetCampaign?id=${cData.schedule.UniqueID}`} target='_blank' rel="noopener noreferrer" >
                  Reset Campaign

                </a>) : 'NA'}
            </div>

          </div>
          <div className="data-field">
            <div className="data-parameter">Reports</div>
            <div className="data-value">
              <a href={`https://app.gmass.co/report?c=${cData.campaign.UniqueID}`} target='_blank' rel="noopener noreferrer" >
                Live Report</a>{' '}|{' '}
              <a href={`https://app.gmass.co/gmass/downloadcsv?C=${cData.campaign.UniqueID}&RT=1`} target='_blank' rel="noopener noreferrer" >
                Replies</a>{' '}|{' '}
              <a href={`https://app.gmass.co/gmass/downloadcsv?C=${cData.campaign.UniqueID}&RT=o`} target='_blank' rel="noopener noreferrer" >
                Opens</a>{' '}|{' '}
              <a href={`https://app.gmass.co/gmass/downloadcsv?C=${cData.campaign.UniqueID}&RT=c`} target='_blank' rel="noopener noreferrer" >
                Clicks</a>{' '}|{' '}
              <a href={`https://app.gmass.co/gmass/downloadcsv?C=${cData.campaign.UniqueID}&RT=u`} target='_blank' rel="noopener noreferrer" >
                Unsubscribes</a>{' '}|{' '}
              <a href={`https://app.gmass.co/gmass/downloadcsv?C=${cData.campaign.UniqueID}&RT=b`} target='_blank' rel="noopener noreferrer" >
                Bounces</a>{' '}|{' '}
            </div>
          </div>
          <div className="data-field">
            <div className="data-parameter">Sent Count</div>
            <div className="data-value">{cData.campaign.SentCount}</div>
          </div>
          <div className="data-field">
            <div className="data-parameter">Draft Details</div>
            <div className="data-value"><button className="Campaign-Details-Button show-parameters-button" onClick={this.toggleDraftDetails}> Show Parameters </button></div>
          </div>
          <div className="data-field">
            <div className="data-parameter">Campaign TimeZone</div>
            <div className="data-value">{cData.schedule.Parameters ? JSON.parse(cData.schedule.Parameters).FutureSendDateTime.split(' ')[2] : 'NA'}</div>
          </div>
        </div>
        <div className="CampaignResult-campaignInfo-Sheet-data">
          <div className="data-field">
            <div className="data-parameter">Google Sheet</div>
            <div className="data-value">
              {cData.sheet ?
                (<a href={`https://www.gmass.co/gmass/GetRawDataFromSheetV4?emailaddress=${uData[0].EmailAddress}&spreadsheetid=${cData.sheet.Spreadsheet}&v4worksheetid=${cData.sheet.WorksheetIDV4}`} target='_blank' rel="noopener noreferrer" >
                  {cData.sheet.SpreadsheetName} {' --> '} {cData.sheet.WorksheetName}
                </a>) : 'NA'
              }

            </div>
          </div>
          {cData.sheet && <div className="data-field">
            <div className="data-parameter">KeepDuplicates | UpdateSheet | AndOr | FilterCriteria</div>
            <div className="data-value"> {cData.sheet.KeepDuplicates ? 'Yes ' : 'No '}
              | {cData.sheet.UpdateSheet ? 'Yes ' : 'No '}
              | {`${cData.sheet.AndOr ? cData.sheet.AndOr.toUpperCase() : 'NA'} `}
              | {cData.sheet.FilterCriteria && cData.sheet.FilterCriteria.length ? `${cData.sheet.FilterCriteria} ` : 'None'}
            </div>
          </div>
          }
          <div className="data-field">
            <div className="data-parameter">Recipient Alias ID</div>
            <div className="data-value">
              {cData.sheet ?
                (<a href={`https://www.gmass.co/gmass/generaterecipientlistfromgooglesheetsjustlistv4?emailaddress=${uData[0].EmailAddress}&spreadsheetid=${cData.sheet.Spreadsheet}&worksheetid=${cData.sheet.WorksheetIDV4}`} target='_blank' rel="noopener noreferrer" >
                  {cData.sheet.AliasAddress}
                </a>) : 'NA'
              }

            </div>
          </div>
        </div>
        <div className="CampaignResult-campaignInfo-button-section">
          <button className="Campaign-Details-Button">
            <a target='_blank' rel="noopener noreferrer" href={`/log/outbound/${cData.campaign.id}`}>
              Outbound Logs
            </a>
          </button>
          <button className="Campaign-Details-Button">
            <a target='_blank' rel="noopener noreferrer" href={`/log/drafts/${cData.campaign.id}`}>
              Draft Edits
            </a>
          </button>
          <button className="Campaign-Details-Button">
            <a target='_blank' rel="noopener noreferrer" href={`/log/process/${cData.campaign.id}`}>
              Processing Logs
            </a>
          </button>
          <button className="Campaign-Details-Button">
            <a target='_blank' rel="noopener noreferrer" href={`/log/sheet/${uData[0].EmailAddress}`}>
              Sheet Logs
            </a>
          </button>
        </div>
        {
          this.state.DraftDetailsModal && (<DraftDetails toggleDraftDetails={this.toggleDraftDetails} />)
        }
      </React.Fragment>

    )
  }

  subscriptionAction = (event) => {
    event.target.disabled = true;
    if (event.target.id === 'COMP-BUTTON') {
      console.log(event.target.id)
      this.props.compAccount(this.props.campaign.uData[0].EmailAddress)
        .then((response) => {
          event.target.disabled = false;
          if (response === 'success') {
            window.open(`/campaign/${this.props.campaign.cData ? this.props.campaign.cData.campaign.id : this.props.campaign.uData[0].EmailAddress}`, "_self")
          } else {
            window.alert('Subscription cancellation failed, something went wrong....')
          }
        })
    }
    if (event.target.id === 'CANCEL-SUBSCRIPTION-BUTTON') {
      console.log(event.target.id)

      this.props.cancelSubscription(this.props.campaign.uData[0].EmailAddress)
        .then((response) => {
          event.target.disabled = false;
          if (response === 'success') {
            window.open(`/campaign/${this.props.campaign.cData ? this.props.campaign.cData.campaign.id : this.props.campaign.uData[0].EmailAddress}`, "_self")
          } else {
            window.alert('Subscription cancellation failed, something went wrong....')
          }
        })

    }

    // setTimeout(()=>{
    //   event.target.disabled = false;

    //   window.open(`/campaign/${this.props.campaign.cData ? this.props.campaign.cData.campaign.id : this.props.campaign.uData[0].EmailAddress}`,"_self")
    // },5000)

  }

  conditionalRendering = () => {
    let { uData, cData } = this.props.campaign


    if (uData) {
      return (

        <div className="CampaignResult-data">
          <div className="CampaignResult-campaignInfo">
            <div className="CampaignResult-campaignInfo-title">Campaign Information</div>
            <div className="CampaignResult-campaignInfo-spacer"></div>
            {
              cData && cData.schedule ? this.renderCampaignData(cData, uData) : ''
            }
          </div>

          <div className="CampaignResult-userInfo">
            <div className="CampaignResult-userInfo-title">User Information</div>
            <div className="CampaignResult-userInfo-spacer"></div>
            <div className="CampaignResult-userInfo-data">
              <div className="data-field">
                <div className="data-parameter">Email Address</div>
                <div className="data-value"><a style={{ textDecoration: 'none', color: '#2170F4' }} href={`https://www.gmass.co/dashboard/email?email=${uData[0].EmailAddress}`} target="_blank" rel="noopener noreferrer" >{uData[0].EmailAddress}</a></div>
              </div>
              <div className="data-field">
                <div className="data-parameter">CreatedAt</div>
                <div className="data-value">{new Date(uData[0].CreateDate).toGMTString()}</div>
              </div>
              <div className="data-field">
                <div className="data-parameter">OAuthStatus</div>
                <div className="data-value"><svg width="6" height="6" viewBox="0 0 6 6" className="state-logo"><circle cx="3" cy="13" r="3"
                  fill={uData[0].OAuthActive ? "#19B05F" : "#F27383"}
                  fillRule="evenodd" transform="translate(0 -10)"></circle></svg>
                  {uData[0].OAuthActive ? ' Active' : ' InActive'}
                  <br />
                  <span style={{ fontSize: '0.8em' }}>{new Date(uData[0].RefreshDate).toGMTString()}</span>
                </div>
              </div>
              <div className="data-field">
                <div className="data-parameter">Plan</div>
                <div className="data-value">{uData[0].AccountStatus === 'a' ? 'COMPED ' : uData[0].AccountStatus === 'b' ? 'PREMIUM ' : uData[0].AccountStatus === 'c' ?
                  'STANDARD ' : uData[0].AccountStatus === 'd' ? 'MINIMAL ' : uData[0].AccountStatus === 'e' ? 'ENTERPRISE ' : 'FREE '} <span className="data-value-team"> {uData[0].TeamMaster ? 'Team Master' : uData[0].WhoIsMyMaster ? 'Team Member' : ''}</span>
                </div>
              </div>
              <div className="data-field">
                <div className="data-parameter">Payment Method</div>
                <div className="data-value">{this.calculatePaymentMethod(uData[0])}</div>
              </div>
              <div className="data-field">
                <div className="data-parameter">Tracking Domain</div>
                <div className="data-value"><span style={{ fontSize: '0.8em', color: 'red' }}>{"(Open) "}</span>{uData[0].openTrackingDomain}</div><br></br>
                <div className="data-value"><span style={{ fontSize: '0.8em', color: 'red' }}>{"(Click) "}</span>{uData[0].clickTrackingDomain}</div>
              </div>

              {uData[0].AccountStatus === 'f' ? (<button className="Campaign-Details-Button" style={{ marginTop: '2%' }} id="COMP-BUTTON" onClick={this.subscriptionAction}> COMP Account </button>) : uData[0].AccountStatus === 'a' ?
                (<button className="Campaign-Details-Button" style={{ marginTop: '2%' }} onClick={this.subscriptionAction} id="CANCEL-SUBSCRIPTION-BUTTON"> Cancel Subscription </button>) : ''
              }
            </div>

            {/* Warmup is deprecated */}
            <div className="CampaignResult-userInfo-warmup-data">
              <div className="data-field">
                <div className="data-parameter">Affiliate Code</div>
                <div className="data-value">
                 {uData[0].AffiliateCodeToGiveOut.toLowerCase().replace(/-/g, "")}
                </div>
              </div>
    
            </div>
            <div className="CampaignResult-userInfo-smtp-data">
              <h2>SMTP Server List</h2>
              <table>
                <thead>
                  <tr>
                    <th>Server</th>
                    <th>User</th>
                    <th>Password</th>
                    <th>Default Server</th>
                  </tr>
                </thead>
                <tbody>
                  {uData[0].smtpServers.map((server) => (
                    <tr key={server.id}>
                      <td>{server.smtpserver} ({server.smtpport})</td>
                      <td>{server.smtpusername}</td>
                      <td className="password-cell ">{server.smtppassword}</td>
                      <td className={server.DefaultServer ? 'default-server-yes' : 'default-server-no'}>
                        {server.DefaultServer ? 'Yes' : 'No'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="CampaignResult-default">
          <img src={campaignResultDefaultImg} alt="Default" />
          <div> Let The Search Begin!</div>
        </div>
      )
    }

  }

  render() {

    return (
      <div className="CampaignResult">
        {this.conditionalRendering()}

      </div>

    );
  }
}


const mapStateToProps = (state) => {
  return { campaign: state.campaign };
};

export default connect(mapStateToProps, { cancelSubscription, compAccount })(CampaignResult);
